import QuestionTitle from "./QuestionTitle";

export default QuestionTitle;
